import { createContext } from 'react';
import { COLOR_PALETTE } from 'constants/appStyling/defaults';

const ReaderSettingsValuesContext = createContext({
  palette: COLOR_PALETTE,
});

export default ReaderSettingsValuesContext;
